var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.couponInvalid)?_c('v-alert',{attrs:{"type":"error","close-label":"cerrar"},scopedSlots:_vm._u([{key:"close",fn:function(){return [_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.closeInvalid}},[_c('v-icon',[_vm._v("close")])],1)]},proxy:true}],null,false,3221801398)},[_c('span',[_vm._v("Cupón Invalido")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }